import { toServer } from '../../util/ServerSocket';
export function provinceWarRequest(data: Record<string,any>): Promise<any> {
  return new Promise((resolve,reject)=>{
    const timer=window.setTimeout(()=>reject(Error('เชื่อมต่อกิจกรรมหมดเวลา กรุณาลองใหม่')),10000);
    toServer('provinceWar',data,(reply:any)=>{
      window.clearTimeout(timer);
      if(reply?.ok)resolve(reply.result);else reject(Error(reply?.error||'ไม่สามารถเชื่อมต่อกิจกรรมได้'));
    });
  });
}
